import {CartItem} from './cartItem';
import {Subscription} from './subscription';
import {Service} from './service';
import {ShopPortfolio} from './shop-portfolio';

export class Cart {
  items: CartItem[];
  totalPrice: number;

  constructor() {
    this.items = [];
  }
}

export type GenericProduct = Subscription | Service | ShopPortfolio;
